<template>
  <div class="back-button">
    <button
      class="back-button__button"
      @click="handleClick"
      :disabled="disabled"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import pinia from '../../core/pinia';
import { useConfigStore, useStepsStore } from '../../stores';

interface IProps {
  disabled?: boolean; 
};
defineProps<IProps>();
const emit = defineEmits(['click']);

const stepsStore = useStepsStore(pinia);
const configStore = useConfigStore(pinia);

const steps = computed(() => stepsStore.getSteps);
const isFirstStep = computed(() => stepsStore.getCurrentStep === steps.value[0].name);
const backEvent = computed(() => configStore.getBackEvent);

function handleClick() {
  if (isFirstStep.value && !!backEvent.value) {
    backEvent.value();
  } else {
    stepsStore.prevStep();
  }
  emit('click');
}
</script>

<style scoped lang="scss">
.back-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &__button {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: center;
    vertical-align: middle;
    color: #78858C;
    text-transform: uppercase;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #78858C;
    background: none;
    cursor: pointer;
  }
}
</style>